import React from 'react';
import PropTypes from 'prop-types';


const styles = {
  top: {
    paddingTop: '20px',
  },
};

class Title extends React.Component {
  render() {
    const { label, top } = this.props;
    return (
      <div style={top ? styles.top : null}>
        <p className="Text-Question"> {label} </p>
      </div>
    );
  }
};

Title.defaultProps = {
  top: true, 
};

Title.propTypes = {
  label: PropTypes.string.isRequired,
  top: PropTypes.bool
}

export default Title;
